module.exports = __webpack_public_path__ + "static/media/Back-Upper-Arm(R) v2.ebde7ca5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Back-Upper-Arm(R) v2.png
// module id = 414
// module chunks = 0